(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  function topLevelDropdownItem(target) {
    if (!(target instanceof Element)) return null;
    const item = target.closest('.header-menu .menu-list__list-item:not([slot="overflow"])');
    if (!item) return null;
    return item.querySelector(':scope > .menu-list__submenu') ? item : null;
  }

  function blockHoverOpen(event) {
    if (!desktopQuery.matches) return;
    if (!topLevelDropdownItem(event.target)) return;
    event.stopImmediatePropagation();
  }

  function closeOpenMenus(exceptButton = null) {
    document
      .querySelectorAll('.header-menu .menu-list__disclosure[aria-expanded="true"]')
      .forEach((button) => {
        if (button === exceptButton) return;
        button.click();
      });
  }

  function stripHoverActions() {
    document
      .querySelectorAll('.header-menu .menu-list__list-item:not([slot="overflow"])')
      .forEach((item) => {
        item.removeAttribute('on:pointerenter');
        item.removeAttribute('on:pointerleave');
      });
  }

  document.addEventListener('pointerenter', blockHoverOpen, true);
  document.addEventListener('pointerleave', blockHoverOpen, true);

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!desktopQuery.matches || !(event.target instanceof Element)) return;

      const disclosure = event.target.closest('.header-menu .menu-list__disclosure');
      if (disclosure) {
        closeOpenMenus(disclosure);
        return;
      }

      if (event.target.closest('.header-menu .menu-list__submenu')) return;
      closeOpenMenus();
    },
    true
  );

  window.addEventListener(
    'scroll',
    () => {
      if (desktopQuery.matches) closeOpenMenus();
    },
    { passive: true }
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripHoverActions, { once: true });
  } else {
    stripHoverActions();
  }
})();
